import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useInjectReducer } from 'redux-injectors';
import { authProfile } from 'redux/auth/selectors';
import { useZonesQuery } from 'queries/useZonesQuery';
import { name, reducer, actions } from './slice';
import { zoneItemsSelector } from './selectors';

export default function useZones() {
  useInjectReducer({ key: name, reducer });
  const dispatch = useDispatch();
  const profile = useSelector(authProfile);
  const items = useSelector(zoneItemsSelector);

  const { data } = useZonesQuery(profile);

  useEffect(() => {
    if (!data || items.length > 0) return;
    dispatch(actions.success(data));
  }, [data, dispatch, items.length]);
}
